import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachMonApi } from "../../../api/ke-hoach/keHoachMonApi";
import { IKeHoachMonSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eKeHoachMonHocNamHocHocKyActionIds, IKeHoachMonHocNamHocHocKyActionTypeBase, IKeHoachMonHocNamHocHocKyActionTypes } from "../../action-types/ke-hoach/IKeHoachMonHocNamHocHocKy";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.keHoach.keHoachMonHocNamHocHocKy;
export function* keHoachMonHocNamHocHocKySaga(): any {
    yield takeEvery(eKeHoachMonHocNamHocHocKyActionIds.LOAD_KE_HOACH_MON_BY_CTDT_START, loadKeHoachMonWorker);
}


function* loadKeHoachMonWorker(action: IKeHoachMonHocNamHocHocKyActionTypes): any {
    const payload = action.payload as IKeHoachMonHocNamHocHocKyActionTypeBase<IKeHoachMonSelectRequest>;
    const res: IBaseRespone = yield call(keHoachMonApi.Select, payload.data);
    if (res.is_success) {
        yield put(mainAction.LOAD_KE_HOACH_MON_BY_CTDT_SUCCESS({
            id_dt: payload.id_dt,
            data: res.data
        }));
    } else {
        yield put(
            mainAction.LOAD_KE_HOACH_MON_BY_CTDT_ERROR({
                id_dt: payload.id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}

// function* updateWorker(action: IKeHoachMonHocNamHocHocKyActionTypes): any {
//     const payload = action.payload as IKeHoachMonHocNamHocHocKyActionTypeBase<IChuongTrinhDaoTaoChiTiet[]>;
//     const res: IBaseRespone = yield call(chuongTrinhDaoTaoChiTietApi.Updates, payload.data);
//     if (res.is_success) {
//         yield put(mainAction.UPDATE_SUCCESS({
//             id_dt: payload.id_dt,
//             data: res.data
//         }));
//     } else {
//         yield put(
//             mainAction.UPDATE_ERROR({
//                 id_dt: payload.id_dt,
//                 data: res.message ?? "Có lỗi"
//             })
//         );
//     }
// }
